export { default as informationWithAddresses } from "./information_with_addresses";
export { default as informationWithDetails } from "./information_with_details";
export { default as informationWithPersonalPhones } from "./information_with_personal_phones";
export { default as informationWithPersonalAndProfessionalPhones } from "./information_with_personal_and_professional_phones";
export { default as securitySecretForm } from "./security_secret_form";
export { default as passwordForm } from "./password_form";
